import axios from "axios";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import toast from "../../../template/layout/utility/sa-toast";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	mixins: [StruttureMixin],
	data() {
		return {
			contabilitaDocumentoRighe: [],
			contabilitaDocumentoRighePathResources: "/contabilitadocumentorighe",
			contabilitaTipoDocumentoOptions: [],
			contabilitaTipoDocumentoPathResources: "/contabilitadocumentotipo",
			contabilitaCausaliDocumentoOptions: [],
			contabilitaCausaliDocumentoPathResources: "/contabilitadocumentocausali",
			contabilitaMetodiPagamentoOptions: [],
			contabilitaMetodiPagamentoPathResources: "/contabilitametodipagamento",
			contabilitaIvaOptions: [],
			contabilitaIvaPathResources: "/contabilitatabellaiva",
			contabilitaTipoSpesaOptions: [],
			contabilitaTipoSpesaPathResources: "/contabilitatipospesa",
			contabilitaTipoDocumento: null,
			contabilitaCausaleTipoDocumento: null,
			documentoJsonDataDettagliDocumento: {
				causaleCodice: null,
				causaleDocumentoDescrizione: null,
				causaleDocumentoId: null,
				tipoDocumentoCodice: null,
				tipoDocumentoDescrizione: null,
				tipoDocumentoId: null,
				documentoData: new Date().getTime(),
				causaleDocumentoOperazioneContabile: null,
				causaleDocumentoOperazioneMagazzino: null,
			},
			documentoJsonDataDestinazione: {
				soggettoNome: null,
				soggettoCognomeRagione: null,
				soggettoCap: null,
				soggettoCodiceFiscale: null,
				soggettoId: null,
				soggettoPartitaIva: null,
				soggettoProvincia: null,
				soggettoLocalitaCodiceIstat: null,
				soggettoLocalita: null,
				soggettoIndirizzo: null,
				magazzinoCap: null,
				magazzinoCodice: null,
				magazzinoDescrizione: null,
				magazzinoId: null,
				magazzinoIndirizzo: null,
				magazzinoLocalita: null,
				magazzinoLocalitaCodiceIstat: null,
				magazzinoProvincia: null,
				metodoPagamentoDescrizione: null,
				metodoPagamentoId: null,
				destinazioneMerceDescrizione: null,
				destinazioneMerceIndirizzo: null,
				destinazioneMerceCap: null,
				destinazioneMerceLocalita: null,
				destinazioneMerceProvincia: null
			},

			documentoJsonData: {
				causaleCodice: null,
				causaleDocumentoDescrizione: null,
				causaleDocumentoId: null,
				causaleDocumentoOperazioneContabile: null,
				causaleDocumentoOperazioneMagazzino: null,
				documentoColli: 0,
				documentoData: new Date().getTime(),
				documentoImballo: "",
				documentoMarcaBollo: "",
				documentoMarcaBolloImporto: 0,
				documentoMarcaBolloImportoMinimo: 0,
				documentoMarcaBolloNumero: "--",
				documentoMarcaBolloVirtuale: false,
				documentoNote: null,
				documentoNoteInterne: "",
				documentoNumero: null,
				documentoPorto: "FRANCO",
				documentoSpeseTrasporto: 0,
				documentoStato: null,
				documentoTotale: 0,
				documentoTotaleImponibile: 0,
				documentoTotaleImposta: 0,
				documentoTrasportoCausale: null,
				documentoTrasportoCura: "CEDENTE",
				documentoTrasportoDataOraInizio: new Date().getTime(),
				documentoVettore: null,
				id: null,
				magazzinoCap: null,
				magazzinoCodice: null,
				magazzinoDescrizione: null,
				magazzinoId: null,
				magazzinoIndirizzo: null,
				magazzinoLocalita: null,
				magazzinoLocalitaCodiceIstat: null,
				magazzinoProvincia: null,
				metodoPagamentoDescrizione: null,
				metodoPagamentoId: null,
				proprietario: null,
				soggettoCap: null,
				soggettoCodiceFiscale: null,
				soggettoCognomeRagione: null,
				soggettoId: null,
				soggettoIndirizzo: null,
				soggettoLocalitaCodiceIstat: null,
				soggettoNome: null,
				soggettoPartitaIva: null,
				soggettoProvincia: null,
				strutturaCodice: null,
				strutturaDenominazione: null,
				strutturaDescrizioneBanca: null,
				strutturaEmail: null,
				strutturaIban: null,
				strutturaPartitaIva: null,
				strutturaPec: null,
				strutturaTelefono: null,
				strutturaIndirizzo: null,
				strutturaLocalitaCodiceIstat: null,
				strutturaProvincia: null,
				strutturaFax: null,
				strutturaCodiceFiscale: null,
				strutturaCap: null,
				tipoDocumentoCodice: null,
				tipoDocumentoDescrizione: null,
				tipoDocumentoId: null,
				righeDocumento: [],
				righeDocumentoIva: [],
				righePagamenti: [],
				documentiCollegati: [],
				destinazioneMerceDescrizione: null,
				destinazioneMerceIndirizzo: null,
				destinazioneMerceCap: null,
				destinazioneMerceLocalita: null,
				destinazioneMerceProvincia: null,
			},
		};
	},
	methods: {
		contabilitaSetJsonData(jsonData) {
			this.documentoJsonData = jsonData;
		},
		contabilitaResetDocumentoJson() {
			this.documentoJsonData = {
				causaleCodice: null,
				causaleDocumentoDescrizione: null,
				causaleDocumentoId: null,
				causaleDocumentoOperazioneContabile: null,
				causaleDocumentoOperazioneMagazzino: null,
				documentoColli: null,
				documentoData: null,
				documentoImballo: null,
				documentoMarcaBollo: null,
				documentoMarcaBolloImporto: 0,
				documentoMarcaBolloImportoMinimo: 0,
				documentoMarcaBolloNumero: "---",
				documentoMarcaBolloVirtuale: false,
				documentoNote: null,
				documentoNoteInterne: null,
				documentoNumero: null,
				documentoPorto: null,
				documentoSpeseTrasporto: null,
				documentoStato: null,
				documentoTotale: null,
				documentoTotaleImponibile: null,
				documentoTotaleImposta: null,
				documentoTrasportoCausale: null,
				documentoTrasportoCura: null,
				documentoTrasportoDataOraInizio: null,
				documentoVettore: null,
				id: null,
				magazzinoCap: null,
				magazzinoCodice: null,
				magazzinoDescrizione: null,
				magazzinoId: null,
				magazzinoIndirizzo: null,
				magazzinoLocalita: null,
				magazzinoLocalitaCodiceIstat: null,
				magazzinoProvincia: null,
				metodoPagamentoDescrizione: null,
				metodoPagamentoId: null,
				soggettoCap: null,
				soggettoCodiceFiscale: null,
				soggettoCognomeRagione: null,
				soggettoId: null,
				soggettoIndirizzo: null,
				soggettoLocalitaCodiceIstat: null,
				soggettoNome: null,
				soggettoPartitaIva: null,
				soggettoProvincia: null,
				strutturaCodice: null,
				strutturaDenominazione: null,
				strutturaDescrizioneBanca: null,
				strutturaEmail: null,
				strutturaIban: null,
				strutturaPartitaIva: null,
				strutturaPec: null,
				strutturaTelefono: null,
				strutturaIndirizzo: null,
				strutturaLocalitaCodiceIstat: null,
				strutturaProvincia: null,
				strutturaFax: null,
				strutturaCodiceFiscale: null,
				strutturaCap: null,
				tipoDocumentoCodice: null,
				tipoDocumentoDescrizione: null,
				tipoDocumentoId: null,
				righeDocumento: [],
				righeDocumentoIva: [],
			};
		},
		contabilitaMetodiPagamentoLoadData() {
			let link = process.env.VUE_APP_PATH_API + this.contabilitaMetodiPagamentoPathResources;
			this.contabilitaMetodiPagamentoOptions = [];
			axios.get(link)
				.then((response) => {
					this.contabilitaMetodiPagamentoOptions = response.data.data.list;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		contabilitaLottoMatricolaByLottoMatricola(lottoMatricola, callBack) {
			let link = process.env.VUE_APP_PATH_API + "/magazzinoarticolilottiscadenze/bycodice" + "/" + lottoMatricola;
			this.contabilitaMetodiPagamentoOptions = [];
			axios.get(link)
				.then((response) => {
					callBack(response)
				})
				.catch((error) => {
					toast.error(error)
				});
		},
		contabilitaTipoSpesaLoadData() {
			let link = process.env.VUE_APP_PATH_API + this.contabilitaTipoSpesaPathResources;
			this.contabilitaTipoSpesaOptions = [];
			axios.get(link)
				.then((response) => {
					this.contabilitaTipoSpesaOptions = response.data.data.list;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		contabilitaTabellaIvaLoadData() {
			let link = process.env.VUE_APP_PATH_API + this.contabilitaIvaPathResources;
			this.contabilitaIvaOptions = [];
			axios.get(link)
				.then((response) => {
					this.contabilitaIvaOptions = response.data.data.list;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		contabilitaCausaliDocumentoLoadData(idTipoDocumento) {
			let link = process.env.VUE_APP_PATH_API + this.contabilitaCausaliDocumentoPathResources;
			this.contabilitaCausaliDocumentoOptions = [];
			axios.get(link, { params: { idTipoDocumento: idTipoDocumento } })
				.then((response) => {
					this.contabilitaCausaliDocumentoOptions = response.data.data.list;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		contabilitaTipoDocumentoLoadData(codiceStruttura) {
			this.contabilitaTipoDocumentoOptions = [];
			let link = process.env.VUE_APP_PATH_API + "/contabilitadocumentotipo";
			axios.get(link, { params: { codiceStruttura: codiceStruttura } })
				.then((response) => {
					this.contabilitaTipoDocumentoOptions = response.data.data.list;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		contabilitaTipoDocumentoByCodiceLoadData(codiceStruttura, codiceTipoDocumento, contabilitaTipoDocumentoCallback) {
			let me = this;
			this.openShowModalLoading();
			let link = process.env.VUE_APP_PATH_API + me.contabilitaTipoDocumentoPathResources + "/codice/" + codiceTipoDocumento;
			axios.get(link, { params: { codiceStruttura: codiceStruttura } })
				.then((response) => {
					this.contabilitaTipoDocumento = response.data.data;
					this.closeShowModalLoading();
					contabilitaTipoDocumentoCallback(this.contabilitaTipoDocumento);
				})
				.catch((error) => {
					let message = error.message;
					if (error.request.status) {
						message = "Risorsa non trovata";
					} else if (error.response) {
						if (error.response.data) {
							message = error.response.data.messaggio;
						}
					}
					this.$bvToast.toast("Errore nel recupero dati: " + message, {
						title: "",
						variant: "danger",
						solid: true,
					});
					this.closeShowModalLoading();
				});
		},
		contabilitaCausaliTipoDocumentoByCodiceLoadData(codiceStruttura, codiceTipoDocumento, codiceCausale, contabilitaCausaleTipoDocumentoCallback, contabilitaCausaleTipoDocumentoCallbackError = null) {
			let me = this;
			this.openShowModalLoading();
			let link = process.env.VUE_APP_PATH_API + me.contabilitaCausaliDocumentoPathResources + "/codice/" + codiceCausale;
			axios.get(link, { params: { codiceStruttura: codiceStruttura, codiceTipoDocumento: codiceTipoDocumento } })
				.then((response) => {
					this.contabilitaCausaleTipoDocumento = response.data.data;

					this.documentoJsonData.causaleCodice = this.contabilitaCausaleTipoDocumento.codiceCausale;
					this.documentoJsonData.causaleDocumentoDescrizione = this.contabilitaCausaleTipoDocumento.descrizioneCausale;
					this.documentoJsonData.causaleDocumentoId = this.contabilitaCausaleTipoDocumento.id;
					this.documentoJsonData.causaleDocumentoOperazioneContabile = this.contabilitaCausaleTipoDocumento.operazioneContabile;
					this.documentoJsonData.causaleDocumentoOperazioneMagazzino = this.contabilitaCausaleTipoDocumento.operazioneMagazzino;
					this.documentoJsonData.tipoDocumentoCodice = this.contabilitaCausaleTipoDocumento.codiceTipoDocumento;
					this.documentoJsonData.tipoDocumentoDescrizione = this.contabilitaCausaleTipoDocumento.descrizioneTipoDocumento;
					this.documentoJsonData.tipoDocumentoId = this.contabilitaCausaleTipoDocumento.idTipoDocumento;
					this.documentoJsonData.documentoData = new Date().getTime();
					this.closeShowModalLoading();
					contabilitaCausaleTipoDocumentoCallback(this.contabilitaCausaleTipoDocumento);
				})
				.catch((error) => {
					if (contabilitaCausaleTipoDocumentoCallbackError == null) {
						let message = error.message;
						if (!error.request.status) {
							message = "Risorsa non trovata";
						} else if (error.response) {
							if (error.response.data) {
								message = error.response.data.messaggio;
							}
						}
						this.$bvToast.toast("Errore nel recupero dati: " + message, {
							title: "",
							variant: "danger",
							solid: true,
						});
					} else {
						contabilitaCausaleTipoDocumentoCallbackError(error);
					}

					this.closeShowModalLoading();
				});
		},
		contabilitaDocumentoRigheLoadData(filtro) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.contabilitaDocumentoRighePathResources;
			axios.get(link, { params: filtro })
				.then((response) => {
					this.contabilitaDocumentoRighe = response.data.data.list;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		getTipoDocumentoDescrizione(idTipoDocumento) {
			let descrizione = " ";
			this.contabilitaTipoDocumentoOptions.forEach((element) => {
				if (element.id === idTipoDocumento) {
					descrizione = element.descrizioneTipoDocumento;
				}
			});
			return descrizione;
		},
		getDescriptionCasuali(id) {
			let descrizione = " ";
			this.contabilitaCausaliDocumentoOptions.forEach((element) => {
				if (element.id === id) {
					descrizione = element.descrizioneCausale;
				}
			});
			return descrizione;
		},
		setDatiStruttura() {
			let tmpPresidio = window.localStorage.getItem("presidio");
			if (tmpPresidio) {
				this.presidio = JSON.parse(tmpPresidio);
				this.strutturaLoadDataById(this.presidio.idStruttura, this.setContabilitaDocumentoDatiStruttura);
			}
		},

		setContabilitaDocumentoDatiStruttura() {
			this.documentoJsonData.strutturaCodice = this.strutturaJsonData.codiceStruttura;
			this.documentoJsonData.strutturaDenominazione = this.strutturaJsonData.denominazione;
			this.documentoJsonData.strutturaEmail = this.strutturaJsonData.email;
			this.documentoJsonData.strutturaIban = this.strutturaJsonData.iban;
			this.documentoJsonData.strutturaPartitaIva = this.strutturaJsonData.partitaIva;
			this.documentoJsonData.strutturaPec = this.strutturaJsonData.pec;
			this.documentoJsonData.strutturaTelefono = this.strutturaJsonData.telefono;
			this.documentoJsonData.strutturaIndirizzo = this.strutturaJsonData.indirizzo;
			this.documentoJsonData.strutturaLocalitaCodiceIstat = this.strutturaJsonData.localita;
			this.documentoJsonData.strutturaLocalita = this.strutturaJsonData.localitaDenominazione;
			this.documentoJsonData.strutturaProvincia = this.strutturaJsonData.provincia;
			this.documentoJsonData.strutturaFax = this.strutturaJsonData.fax;
			this.documentoJsonData.strutturaCodiceFiscale = this.strutturaJsonData.codiceFiscale;
			this.documentoJsonData.strutturaCap = this.strutturaJsonData.cap;
		},
	},
};
